import { render, staticRenderFns } from "./tickets.vue?vue&type=template&id=4006b8a8&scoped=true&"
import script from "./tickets.vue?vue&type=script&lang=js&"
export * from "./tickets.vue?vue&type=script&lang=js&"
import style0 from "./tickets.vue?vue&type=style&index=0&id=4006b8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4006b8a8",
  null
  
)

export default component.exports